import type { Cart } from 'src/graphql/generated';
import type { FormData } from 'src/types/appState';

export const isSelectAdPageCompleted = (formData?: FormData, cart?: Cart) =>
  Boolean(
    formData?.selectedProductId || (cart?.items && cart?.items.length > 0),
  );
